import type { DealStageRow, StageCount, WorkspaceStats } from '../../../lib/outreach/types'
import { formatCount, formatMoney } from '../../../lib/outreach/stats'
import { Section } from './Section'
import { SimpleTable, type Column } from './SimpleTable'

function StageList({ title, rows }: { title: string; rows: StageCount[] | undefined }) {
  const list = rows ?? []
  const max = Math.max(1, ...list.map((r) => r.count))
  return (
    <div className="od-pipe">
      <h4 className="od-section-title">{title}</h4>
      {list.length === 0 ? (
        <p className="od-hint">No contacts in this pipeline.</p>
      ) : (
        <ul className="od-pipe-list" aria-label={title}>
          {list.map((r) => (
            <li key={r.stage} className="od-pipe-row">
              <span>{r.stage}</span>
              <div className="od-bar" aria-hidden="true">
                <div
                  className="od-bar-fill"
                  style={{ width: `${Math.round((r.count / max) * 100)}%` }}
                />
              </div>
              <span className="od-pipe-count">{formatCount(r.count)}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

const DEAL_COLUMNS: Column<DealStageRow>[] = [
  { key: 'stage', label: 'Stage', render: (d) => d.stage },
  { key: 'count', label: 'Deals', numeric: true, render: (d) => formatCount(d.count) },
  { key: 'value', label: 'Total value', numeric: true, render: (d) => formatMoney(d.value) },
]

export function PipelineSection({ stats }: { stats: WorkspaceStats }) {
  const other = stats.pipeline.other
  return (
    <>
      <Section title="Pipeline">
        <div className="od-pipes">
          <StageList title="Editorial pipeline" rows={stats.pipeline.editorial} />
          <StageList title="Sales pipeline" rows={stats.pipeline.sales} />
        </div>
        {other && other.length > 0 && (
          <div className="od-pipes">
            <StageList title="Other" rows={other} />
          </div>
        )}
      </Section>
      <Section title="Deals by stage">
        <SimpleTable
          label="Deals by stage"
          columns={DEAL_COLUMNS}
          rows={stats.deals_by_stage}
          rowKey={(d) => d.stage}
          emptyText="No deals yet."
        />
      </Section>
    </>
  )
}
